<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Cadastro de Profissionais</h2>
        <v-spacer></v-spacer>
        <v-btn @click="imprimirCartao()" small color="primary">Imprimir todos cartões</v-btn>
        <v-btn @click="onNewButtonClick()" small color="primary">Novo</v-btn>
      </v-card-title>
      <v-card-text>
        <e-data-table
          :headers="headers"
          :items="profissionais"
          :total="total"
          @refresh="getAll"
          @edit="editItem"
          @delete="deleteItem"
        ></e-data-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>

    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Novo</v-card-title>

        <v-card-text>
          <v-form v-model="valid">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="profissional.nome"
                    :rules="rules.profissionais"
                    label="Nome Profisional"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="!valid"
            :loading="buttonSaveLoadingVisible"
            flat
            @click="onSaveButtonClick()"
          >Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import { showError, showConfirm, retPermissao } from '@/utils'
import profissionalService from '@/services/profissional'
import relatorioService from '@/services/relatorio'
import EDataTable from '@/components/EDataTable'
import store from '@/store'

export default {
  name: 'profissionais',
  components: {
    EDataTable
  },
  data () {
    return {
      profissional: {},
      profissionais: [],
      total: 0,
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Profissionais', value: 'nome', sortable: false },
        { text: 'Cidade', value: 'localidade', sortable: false },
        { text: 'Estado', value: 'uf', sortable: false }],
      dialog: false,
      valid: true,
      rules: {
        nome: [v => !!v || 'Campo Requerido']
      },
      buttonSaveLoadingVisible: false
    }
  },
  methods: {
    async getAll (page, search) {
      try {
        let result = search === '' ? await profissionalService.getAll(page) : await profissionalService.getByNome(search, page)
        this.total = result._meta.total_items
        this.profissionais = result.data
      } catch (error) {
        showError(error)
      }
    },
    editItem (item) {
      var ret = retPermissao('Profissionais', 'alterar')
      if (ret === true) {
        this.$router.push(`/profissionais/editar/${item.id}`)
      }
    },
    async deleteItem (item) {
      var ret = retPermissao('Profissionais', 'excluir')
      if (ret === true) {
        showConfirm(`Tem certeza que deseja remover profissional ${item.nome} ?`, async result => {
          if (result) {
            try {
              this.loading = true
              await profissionalService.delete(item.id)
              this.getAll(1, '')
            } catch (error) {
              showError(error)
            } finally {
              this.loading = false
            }
          }
        })
      }
    },
    onNewButtonClick () {
      var ret = retPermissao('Profissionais', 'incluir')
      if (ret === true) {
        this.$router.push(`/profissionais/criar`)
      }
    },
    async imprimirCartao () {
      try {
        const result = await relatorioService.reportcartao('profissional', store.nome, 0)
        if (result[0].erro === 'S') {
          showError('Atenção: ' + result[0].path)
        } else {
          window.open(result[0].path)
        }
      } catch (error) {
        showError(error)
      }
    }
  }
}
</script>
<style>
.flex{
    height: 60px;
  }
</style>
